module.exports = __webpack_public_path__ + "img/var_date.ddc0c65.svg";